import styled from "styled-components";

export const Close = styled.span`
  width: 10px;
  height: 20px;
  margin-left: 21.5px;
  margin-right: 21px;
  cursor: pointer;
`;
